import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "react-axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMusic } from "@fortawesome/free-solid-svg-icons";
import Card from "react-bootstrap/Card";
import { getRelatedPlaylist } from "~/api/getCustomPlaylists";

const RelatedPlaylists = ({ trackId }) => {
  const [loading, setLoading] = useState(true);
  const [playlists, setPlaylists] = useState([]);
  const load = async () => {
    const resp = await getRelatedPlaylist(axios, trackId);
    // limit to 4 playlists
    resp.data.playlists = resp.data.playlists.slice(0, 4);
    // console.log("🚀 ~ file: RelatedPlaylists.js:14 ~ load ~ resp:", resp);
    setPlaylists(resp.data.playlists);
    setLoading(false);
  };
  useEffect(() => {
    load();
  }, []);

  return (
    (!loading && playlists.length !== 0 && (
      <div className="sideNavSection">
        <h3>
          <FontAwesomeIcon icon={faMusic} style={{ fontSize: 24, marginRight: 8 }} />
          Related Playlists
        </h3>
        <div className="playlistSideNav">
          {playlists.map((p) => (
            <Link to={`/playlist/${p.id}`}>
              <Card body className={`relatedCard text-left${Number(p.collaborative) === 1 ? " is-collaborative" : ""}`}>
                <span>
                  {p.name}
                  {Number(p.collaborative) === 1 && <span className="playlistCollabBadge">Collaborative</span>}
                </span>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    )) ||
    null
  );
};

export default RelatedPlaylists;
